// extracted by mini-css-extract-plugin
module.exports = {"clickableCardWithPopup":"_3ygFMw_3fbrrB5ry-81ZQQ"};